import { render, staticRenderFns } from "./ActConta.vue?vue&type=template&id=40c43a82&scoped=true&"
import script from "./ActConta.vue?vue&type=script&lang=js&"
export * from "./ActConta.vue?vue&type=script&lang=js&"
import style0 from "./ActConta.vue?vue&type=style&index=0&id=40c43a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c43a82",
  null
  
)

export default component.exports